import {
  gdaScore,
  gdaScoreCurated,
  gdaScoreClinicalTrials,
  gdaScoreInferred,
  gdaScoreModels,
  gdaScoreLiterature,
} from '../../AboutHelpers.tsx';

function AboutMetricsGdaScore(): JSX.Element {
  return (
    <div id="gdaScore">
      <h3>GDA Score</h3>
      <p>
        The DISGENET Score (S<sub style={{ fontSize: 'smaller', marginLeft: 2 }}>GDA</sub>) for GDAs is
        computed according to:{' '}
      </p>
      <span>{gdaScore()}</span>
      <br></br>
      <span>{gdaScoreCurated()}</span>
      <br></br>
      <span>{gdaScoreClinicalTrials()}</span>
      <br></br>
      <span>{gdaScoreInferred()}</span>
      <br></br>
      <span>{gdaScoreModels()}</span>
      <br></br>
      <span>{gdaScoreLiterature()}</span>
    </div>
  );
}

export default AboutMetricsGdaScore;